import { track } from './core';

export function trackAppAddVersionClicked(appId, appName) {
  track('app_add_version_clicked', { app_id: appId, app_name: appName });
}

export function trackAppVersionOpened(appId, appName, version) {
  track('app_version_opened', { app_id: appId, app_name: appName, version });
}

export function trackAppFilterChanged(appId, appName, filter) {
  track('app_filter_changed', { app_id: appId, app_name: appName, filter });
}

export function trackScanFileUploadClicked(appId, appName) {
  track('scan_file_upload_clicked', { app_id: appId, app_name: appName });
}

export function trackScanStarted(appId, appName) {
  track('scan_started', { app_id: appId, app_name: appName });
}

export function trackScanStartFailed(appId, appName, error) {
  track('scan_start_failed', { app_id: appId, app_name: appName, error });
}
